import React, { Component } from 'react'

import { Container } from 'components/Layout'
import cn from 'classnames'
import Button from 'components/Button'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import SimpleTable from 'components/Tables/SimpleTable'
import { Form, Field } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import SelectPretty from 'components/Input/SelectPretty/SelectPretty'

export default class NumbersChangeUsagePlanModal extends Component {
  componentWillMount() {
    const { getChangeUsagePlanFee, getSuitableUsagePlans, serviceId } = this.props
    getChangeUsagePlanFee(serviceId)
    getSuitableUsagePlans(serviceId)
  }
  render() {
    const {
      modalConfirm,
      changeUsagePlan,
      serviceId,
      fee,
      date,
      modalCancel,
      handleSubmit,
      usagePlanOptions,
      submitting,
      loading,
      invalid,
    } = this.props
    const submit = formData => changeUsagePlan(serviceId, formData).then(modalConfirm)

    return (
      <Container paddingTop paddingBottom className="sm">
        <Form onSubmit={handleSubmit(submit)}>
          <div className={cn(sText.descrip2, sText.center)}>Change Usage Plan</div>
          <br />
          <br />
          <br />
          <SimpleTable>
            <div>
              <div>Date:</div>
              <div>{date}</div>
            </div>
            <div>
              <div>Fee:</div>
              <div>${fee}</div>
            </div>
          </SimpleTable>
          <br />
          <br />
          <Field
            label="Usage Plan"
            name="usagePlanAlias"
            component={SelectPretty}
            options={usagePlanOptions}
            validate={[vRequired]}
          />
          <div
            className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
            style={{ marginTop: '40px' }}
          >
            <Button
              color="tertiary"
              type="submit"
              loading={submitting || loading}
              disabled={submitting || loading || invalid}
            >
              Submit
            </Button>
            <br />
            <br />
            <Button plain onClick={modalCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersChangeUsagePlanModal/NumbersChangeUsagePlanModal.jsx